import React, { useContext } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { LanguageContext } from "../languages/LanguageContext";
import SimpleHeader from "../components/SimpleHeader";
import PageTitle from "../components/PageTitle";

const Policy = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='Privacy Policy' />
            <Header />
            <div className='main-container privacy'>
                <SimpleHeader
                    title={"privacyTitle"}
                    route={"privacy"}
                    url={"policy"}
                />
                <section className='privacy-section max-w'>
                    <h3>
                        <span>1</span>
                        {translations[language]["title1"]}
                    </h3>
                    <b>{translations[language]["b1"]}</b>
                    <blockquote>
                        BVO - Bildungsberatung & Vermittlungsagentur GmbH <br /> <br />
                        Aldona Biedermann <br />
                        Ankerhofenstraße 8, Stiege 2 <br />
                        9020 Klagenfurt am Wörthersee <br />
                        Kärnten / Österreich <br /> <br />
                        aldona.biedermann@gmail.com <br />
                    </blockquote>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>2</span>
                        {translations[language]["title2"]}
                    </h3>
                    <span dangerouslySetInnerHTML={{ __html: translations[language]["content2"] }}></span>
                    <ol dangerouslySetInnerHTML={{ __html: translations[language]["list2"] }}></ol>
                    <b>{translations[language]["b2"]}</b>
                    <ol dangerouslySetInnerHTML={{ __html: translations[language]["list2-1"] }}></ol>
                    <p>{translations[language]["p2"]}</p>
                    <b>{translations[language]["b2-1"]}</b>
                    <p dangerouslySetInnerHTML={{ __html: translations[language]["p2-1"] }}></p>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>3</span>
                        {translations[language]["title3"]}
                    </h3>
                    <p>{translations[language]["p3"]}</p>
                    <b>{translations[language]["b3"]}</b>
                    <ol dangerouslySetInnerHTML={{ __html: translations[language]["list3"] }}></ol>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>4</span>
                        {translations[language]["title4"]}
                    </h3>
                    <b>{translations[language]["b4"]}</b>
                    <ol dangerouslySetInnerHTML={{ __html: translations[language]["list4"] }}></ol>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>5</span>
                        {translations[language]["title5"]}
                    </h3>
                    <p>{translations[language]["p5"]}</p>
                    <br />
                    <p>{translations[language]["p5-1"]}</p>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>6</span>
                        {translations[language]["title6"]}
                    </h3>
                    <p>{translations[language]["p6"]}</p>
                    <br />
                    <p>{translations[language]["p6-1"]}</p>
                </section>
                <section className='privacy-section max-w'>
                    <h3>
                        <span>7</span>
                        {translations[language]["title7"]}
                    </h3>
                    <b>{translations[language]["b7"]}</b>
                    <p>{translations[language]["p7"]}</p>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Policy;